<template>
  <div class="ugc-item" @click="bindClickItem(data)">
    <div class="item-top">
      <div class="user-avatar-wrap" @click.stop="bindUserInfo">
        <img class="user-avatar" :src="data.base.user.u_img" alt="" />
        <img
          class="avatar_frame"
          v-if="data.base.user.identity && data.base.user.identity.avatar_frame"
          :src="data.base.user.identity.avatar_frame"
          alt=""
        />
        <img
          class="user-identity"
          v-else-if="
            data.base.user.identity &&
            !data.base.user.identity.desc &&
            data.base.user.identity.img
          "
          :src="data.base.user.identity.img"
          alt=""
        />
      </div>
      <div class="item-top-flex">
        <div class="nickname">{{ data.base.user.u_name }}</div>
        <div
          class="flag-content"
          v-if="data.base.user.identity && data.base.user.identity.desc"
        >
          <img
            class="flag-icon"
            v-if="data.base.user.identity && data.base.user.identity.img"
            :src="data.base.user.identity.img"
            alt=""
          />
          <div class="flag-text">{{ data.base.user.identity.desc }}</div>
        </div>
      </div>
      <div
        v-if="userInfo && userInfo.unify_id != data.base.user.unify_id"
        class="focus-btn"
        :class="{ 'focused-btn': data.base.user.is_follow }"
        @click.stop="bindFocus"
        ><img
          class="add-image"
          v-if="!data.base.user.is_follow"
          src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2026-01/6d58c754186bc97ff92c8a8d45564b80_wh=80_80.webp"
          alt=""
        /><span>{{ data.base.user.is_follow ? '已关注' : '关注' }}</span></div
      >
    </div>
    <div class="dynamic-text">
      <UgcRichText :data="data.base.rich_content" />
    </div>
    <div
      class="image-container"
      v-if="data.base && data.base.image_list && data.base.image_list.length"
    >
      <!-- 单张图 -->
      <template v-if="data.base.cover_type == 1">
        <img
          class="dynamic-image dynamic-image-one"
          :src="data.base.image_list[0].url"
          alt=""
        />
      </template>
      <!-- 四张图 -->
      <template v-if="data.base.cover_type == 2">
        <img
          class="dynamic-image dynamic-image-item"
          v-for="(imageItem, imageIndex) in 4"
          :key="imageIndex"
          :src="data.base.image_list_v2[imageIndex].cover.url"
          alt=""
        />
      </template>
      <div
        class="image-number"
        v-if="data.base.cover_type == 1 && data.base.image_list.length > 1"
        >{{ data.base.image_list.length }}</div
      >
    </div>
    <div class="address-container" v-if="data.base.shop_info">
      <img
        class="address-icon"
        src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2026-01/a500a43224a09d933fba656957d0bf93_wh=80_80.webp"
        alt=""
      />
      <div class="address-name">{{ data.base.shop_info.store_name }}</div>
    </div>
    <div class="like-comment-wrap">
      <!-- 点赞人列表 -->
      <div
        class="like-person-list"
        @click.stop="bindClickLikeList(data)"
        v-if="data.base.like_list && data.base.like_list.length"
      >
        <div
          class="like-person-item"
          v-for="(item1, index1) in data.base.like_list.slice(0, 3)"
          :key="index1"
        >
          <img class="like-person-avatar" :src="item1.head_img" alt="" />
        </div>
        <img
          class="more-person"
          v-if="data.base.like_info.number > 3"
          src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2026-01/2760db8837438ad2368574d4f9d00fe5_wh=80_80.webp"
          alt=""
        />
      </div>
      <div v-else class="not-like-wrap">
        <img class="small-like-icon" :src="data.default_like_info.img" alt="" />
        <div>{{ data.default_like_info.text }}</div>
      </div>
      <!-- 点赞评论信息 -->
      <div class="icon-list">
        <div class="icon-item">
          <img
            class="icon-image like-icon"
            :class="{ 'like-icon-animate': data.base.like_info.is_like }"
            @click.stop="bindLike"
            :src="getLikeIcon(data.base.like_info.is_like)"
            alt=""
          />
          <div class="icon-num" v-if="data.base.like_info.number">{{
            data.base.like_info.number
          }}</div>
        </div>
        <div class="icon-item">
          <img
            class="icon-image comment-icon"
            src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2026-01/ef8097a40c845480fcf1c31cef0a0030_wh=96_96.webp"
            alt=""
          />
          <div class="icon-num" v-if="data.base.comment_info.number">{{
            data.base.comment_info.number
          }}</div>
        </div>
      </div>
    </div>
    <div class="ugc-mask" v-if="!isApp" @click="bindClickMask"></div>
  </div>
</template>

<script>
import UgcRichText from './rich-text.vue'
export default {
  components: { UgcRichText },
  props: {
    data: {
      type: Object,
      default: null
    },
    userInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isApp: false
    }
  },
  created() {
    this.isApp = this.$betterwe.isApp() || true
  },
  methods: {
    getLikeIcon(isLike) {
      return isLike
        ? 'https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2026-01/04f6374318e87d5eab235e9f02497510_wh=96_96.webp'
        : 'https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2026-01/31c195aa63837d8507899c163344ba20_wh=96_96.webp'
    },
    //关注
    bindFocus() {
      this.$emit('focus', this.data)
    },
    //点赞
    bindLike() {
      this.$emit('like', this.data)
    },
    //跳转用户信息
    bindUserInfo() {
      this.$emit('user', this.data)
    },
    bindClickItem() {
      this.$emit('item', this.data)
    },
    bindClickLikeList() {
      this.$emit('likeList', this.data)
    },
    bindClickMask() {
      this.$emit('mask', this.data)
    }
  }
}
</script>
<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}

.ugc-item {
  position: relative;
  padding: 16px 20px;
  background: #ffffff;
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  .ugc-mask {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 1;
  }
  .item-top {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    .user-avatar-wrap {
      position: relative;
      width: 36px;
      height: 36px;
      margin-right: 10px;

      .user-avatar {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        overflow: hidden;
        object-fit: cover;
      }

      .user-identity {
        position: absolute;
        bottom: 0;
        right: -2px;
        width: 14px;
        height: 14px;
      }
      .avatar_frame {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 42px;
        height: 42px;
        object-fit: contain;
      }
    }

    .item-top-flex {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;

      .nickname {
        white-space: nowrap;
        text-overflow: ellipsis;
        font-weight: bold;
        font-size: 14px;
        color: #050b27;
      }

      .flag-content {
        display: flex;
        align-items: center;

        .flag-icon {
          width: 14px;
          height: 14px;
          object-fit: contain;
          margin-right: 1px;
        }

        .flag-text {
          font-size: 12px;
          color: rgba(5, 11, 39, 0.5);
          display: flex;
          align-items: center;
        }
      }
    }

    .focus-btn {
      box-sizing: border-box;
      width: 72px;
      height: 28px;
      background: #ffffff;
      border-radius: 14px;
      border: 0.5px solid #050b27;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      font-size: 12px;
      color: #050b27;

      .add-image {
        width: 10px;
        height: 10px;
        object-fit: contain;
        margin-right: 5px;
        filter: brightness(0);
      }
    }

    .focused-btn {
      opacity: 0.5;
    }
  }

  .dynamic-text {
    width: 100%;
    font-size: 14px;
    color: #050b27;
    margin-bottom: 8px;
  }

  .image-container {
    width: 100%;
    margin-bottom: 7px;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    .image-number {
      position: absolute;
      bottom: 10px;
      right: 10px;
      color: #fff;
      font-size: 24px;
      font-family: Din;
      font-weight: bold;
    }
    .dynamic-image {
      width: 166px;
      height: 166px;
      overflow: hidden;
      border-radius: 4px;
      object-fit: cover;
    }

    .dynamic-image-one {
      width: 100%;
      height: 335px;
      object-fit: cover;
      border-radius: 4px;
      margin-bottom: 3px;
    }

    .dynamic-image-item {
      width: 166px;
      height: 166px;
      margin-bottom: 3px;
    }

    .dynamic-image-item:nth-child(2n + 1) {
      margin-right: 3px;
    }
  }

  .address-container {
    box-sizing: border-box;
    height: 20px;
    background: #ffffff;
    border-radius: 10px;
    border: 0.5px solid rgba(5, 11, 39, 0.2);
    padding: 0px 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 10px;
    color: rgba(5, 11, 39, 0.7);
    margin-bottom: 8px;

    .address-icon {
      width: 14px;
      height: 14px;
      margin-right: 4px;
      opacity: 0.5;
    }

    .address-name {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      font-weight: 500;
      font-size: 10px;
      color: rgba(5, 11, 39, 0.7);
    }
  }

  .like-comment-wrap {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .like-person-list {
      display: flex;
      align-items: center;

      .like-person-item {
        position: relative;
        width: 20px;
        height: 20px;
        margin-right: 7px;

        .like-person-avatar {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          overflow: hidden;
          object-fit: cover;
        }
      }

      .like-person-item::after {
        content: '';
        position: absolute;
        right: -5px;
        bottom: 0px;
        width: 12px;
        height: 12px;
        background-image: url('https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2026-01/c20dd715ab17536a428d8dedbf84aa04_wh=48_48.webp');
        background-size: 100%;
        background-repeat: no-repeat;
      }

      .more-person {
        width: 20px;
        height: 20px;
      }
    }

    .not-like-wrap {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 12px;
      color: rgba(5, 11, 39, 0.5);

      .small-like-icon {
        width: 16px;
        height: 16px;
        margin-right: 5px;
      }
    }

    .icon-list {
      display: flex;
      align-items: center;

      .icon-item {
        display: flex;
        align-items: center;
        margin-right: 14px;

        .icon-image {
          width: 24px;
          height: 24px;
          object-fit: contain;
        }
        .like-icon-animate {
          animation: likeScale 0.2s ease;
        }
        .icon-num {
          margin-left: 3px;
          font-weight: 500;
          font-size: 12px;
          color: rgba(5, 11, 39, 0.5);
        }
      }

      .icon-item:last-child {
        margin-right: 0;
      }
    }
  }
}
@keyframes likeScale {
  0% {
    transform: scale(0.2);
  }
  80% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
</style>
